module.exports = {
      id: "ic-tick-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-tick-usage",
      toString: function () {
        return this.url;
      }
    }